var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Payments-UX-NZ---Lean-MVP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payments_01_NZ-B_payments-DD",
    transform: "translate(-675.000000, -789.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "module_pay-DD",
    transform: "translate(85.000000, 624.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(590.000000, 165.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "#0046AA",
    points: "18.2222222 20 1.75859327e-13 20 1.75859327e-13 1.778 8.19444444 1.778 8.19444444 3.55577778 1.778 3.55577778 1.778 18.2222222 16.4446667 18.222 16.4444444 11.8055556 18.2224444 11.8055556 18.2222222 20"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "#0046AA",
    points: "11.7775556 1.04805054e-13 11.7777778 1.77733333 16.9653333 1.77755556 11.6215556 7.12155556 12.8784444 8.37844444 18.2222222 3.03466667 18.2222222 8.22222222 20 8.22222222 20 1.04805054e-13 11.7775556 1.04805054e-13"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload);
export default __webpack_public_path__ + "static/media/icon-download.cf961c0f.svg";
export { ForwardRef as ReactComponent };